<po-page-default
  p-title="Modulo de Entrada NFs - Documentos - Adicionar"
  [p-actions]="pageActions">

  <po-loading-overlay *ngIf="enviando" p-text="Enviando..."></po-loading-overlay>

  <po-widget
    *ngFor="let grupo of grupos; let i = index"
    [p-title]="'Grupo ' + (i + 1)">

    <!-- CABECALHO DO GRUPO -->
    <div class="po-row">
      <po-select
        class="po-md-3"
        p-label="Filial"
        [ngModel]="grupo.filialCnpj"
        (ngModelChange)="grupo.filialCnpj = $event"
        [ngModelOptions]="{standalone: true}"
        [p-options]="filialOptions"
        p-required>
      </po-select>

      <po-select
        class="po-md-3"
        p-label="Pasta GED"
        [ngModel]="grupo.gedFolder"
        (ngModelChange)="grupo.gedFolder = $event"
        [ngModelOptions]="{standalone: true}"
        [p-options]="gedFolderOptions">
      </po-select>

      <!-- CNAE para grupos NFSe; substituido por Produto Frete em grupos CTe.
           CTe nao usa CNAE - o produto do frete eh resolvido diretamente. -->
      <po-select
        *ngIf="!grupo.fornecedorOculto && !grupoTemCte(grupo)"
        class="po-md-6"
        p-label="Serviço (CNAE)"
        [ngModel]="grupo.servicoCnae"
        (ngModelChange)="grupo.servicoCnae = $event"
        [ngModelOptions]="{standalone: true}"
        [p-options]="cnaeOptions"
        [p-disabled]="carregandoCnaes ? 'true' : 'false'"
        p-required>
      </po-select>

      <po-select
        *ngIf="!grupo.fornecedorOculto && grupoTemCte(grupo)"
        class="po-md-6"
        p-label="Produto Frete"
        [ngModel]="grupo.produtoCte"
        (p-change)="onProdutoCteGrupoChange(grupo, $event)"
        [ngModelOptions]="{standalone: true}"
        [p-options]="produtosCteOptions"
        p-required>
      </po-select>
    </div>

    <div class="po-row">
      <po-input
        class="po-md-3"
        p-label="CNPJ do Emissor"
        p-placeholder="00.000.000/0000-00"
        [(ngModel)]="grupo.cnpjEmissor"
        [ngModelOptions]="{standalone: true}"
        [p-mask]="cnpjMask"
        [p-pattern]="cnpjPattern"
        (p-change)="onCnpjBlur(grupo)"
        p-error-pattern="CNPJ invalido."
        p-required>
      </po-input>

      <po-input
        class="po-md-6"
        p-label="Nome do Fornecedor"
        p-placeholder="Sera preenchido automaticamente"
        [(ngModel)]="grupo.fornecedorNome"
        [ngModelOptions]="{standalone: true}">
      </po-input>
    </div>

    <po-divider></po-divider>

    <!-- DROP ZONE PRINCIPAL: cria 1 documento por arquivo (com PDF como DANFE).
         Para Boletos / Romaneios, arraste direto no slot do documento ja criado. -->
    <div
      class="drop-zone"
      [class.drop-zone--active]="grupo.dragOver"
      (dragover)="onDragOver($event, grupo)"
      (dragleave)="onDragLeave($event, grupo)"
      (drop)="onDrop($event, grupo)">
      <strong>Adicionar várias NFs:</strong> arraste DANFEs aqui (1 NF por arquivo).
      Boletos e Romaneios vão nos slots do documento abaixo.
    </div>

    <!-- DOCUMENTOS DO GRUPO -->
    <div class="doc-card" *ngFor="let doc of grupo.documentos; let d = index">

      <div class="doc-card__head">
        <span class="doc-card__title">Documento {{ d + 1 }}</span>

        <span *ngIf="doc.status === 'ok'"       class="doc-status doc-status--ok"   [title]="doc.mensagem">{{ doc.mensagem }}</span>
        <span *ngIf="doc.status === 'erro'"     class="doc-status doc-status--erro" [title]="doc.mensagem">{{ doc.mensagem }}</span>
        <span *ngIf="doc.status === 'enviando'" class="doc-status doc-status--info" [title]="doc.mensagem">{{ doc.mensagem }}</span>

        <po-button
          p-kind="tertiary"
          p-icon="an an-trash"
          p-small
          p-danger
          (p-click)="excluirDocumento(grupo, d)">
        </po-button>
      </div>

      <div class="po-row">
        <po-input
          class="po-md-3"
          p-label="Número NF"
          [(ngModel)]="doc.numeroNf"
          [ngModelOptions]="{standalone: true}"
          p-pattern="^[A-Za-z0-9]+$"
          p-error-pattern="Use apenas letras e numeros (sem espacos ou simbolos)."
          [p-maxlength]="20"
          p-required>
        </po-input>

        <po-select
          class="po-md-2"
          p-label="Série"
          *ngIf="doc.especie !== 'CTE'"
          [ngModel]="doc.serie"
          (ngModelChange)="doc.serie = $event"
          [ngModelOptions]="{standalone: true}"
          [p-options]="serieOptions"
          p-required>
        </po-select>

        <!-- CTe usa a série REAL do documento (derivada da chave, editável).
             NFSe segue o dropdown S1/S2 acima. -->
        <po-input
          class="po-md-2"
          p-label="Série (CTe)"
          *ngIf="doc.especie === 'CTE'"
          [(ngModel)]="doc.serie"
          [ngModelOptions]="{standalone: true}"
          p-pattern="^[0-9]{1,3}$"
          p-error-pattern="Série do CTe: 1 a 3 dígitos."
          [p-maxlength]="3"
          p-required>
        </po-input>

        <po-datepicker
          class="po-md-3"
          p-label="Emissão"
          p-placeholder="dd/mm/aaaa"
          p-format="dd/mm/yyyy"
          [(ngModel)]="doc.emissao"
          [ngModelOptions]="{standalone: true}"
          p-required>
        </po-datepicker>

        <po-decimal
          class="po-md-2"
          p-label="Valor"
          [(ngModel)]="doc.valor"
          [ngModelOptions]="{standalone: true}"
          [p-decimals-length]="2"
          p-required>
        </po-decimal>

        <po-datepicker
          class="po-md-2"
          p-label="Vencimento"
          p-placeholder="dd/mm/aaaa"
          p-format="dd/mm/yyyy"
          [(ngModel)]="doc.vencimento"
          [p-disabled]="!doc.fin ? 'true' : 'false'"
          [ngModelOptions]="{standalone: true}">
        </po-datepicker>
      </div>

      <div class="po-row">
        <!-- Processo apenas em fluxo normal. Fornecedor oculto dispensa
             processo e usa Conta Contabil + BU + CC + Produto manuais. -->
        <po-input
          *ngIf="!grupo.fornecedorOculto"
          class="po-md-6"
          p-label="Processo"
          p-placeholder="Ex: AC 0123/00"
          [(ngModel)]="doc.processo"
          (p-change)="onProcessoBlur(doc)"
          [ngModelOptions]="{standalone: true}">
        </po-input>

        <po-switch
          class="po-md-3"
          p-label="Gera Financeiro"
          p-label-on="Sim"
          p-label-off="Não"
          [(ngModel)]="doc.fin"
          (p-change)="onFinChange(doc, $event)"
          [ngModelOptions]="{standalone: true}">
        </po-switch>

        <po-switch
          class="po-md-3"
          p-label="Retenção"
          p-label-on="Sim"
          p-label-off="Não"
          [(ngModel)]="doc.retencao"
          [ngModelOptions]="{standalone: true}">
        </po-switch>

      </div>

      <!-- CTe: chave de acesso (44 dig). Extraida do DACTE pelo parser,
           editavel e OBRIGATORIA. O [p-help] mostra se a chave e valida (DV). -->
      <div class="po-row" *ngIf="doc.especie === 'CTE'">
        <po-input
          class="po-md-12"
          p-label="Chave de Acesso (CTe)"
          [(ngModel)]="doc.chaveAcesso"
          [ngModelOptions]="{standalone: true}"
          p-pattern="^[0-9]{44}$"
          p-error-pattern="A chave deve ter 44 dígitos numéricos."
          [p-maxlength]="44"
          [p-help]="chaveCteHelp(doc)"
          p-required>
        </po-input>
      </div>

      <!-- Fluxo CTe: select TES + pedagio + toggle Simples Nacional. TES
           vem da planilha REGRAS CTE filtrada por filial + tipoProcesso
           (default 'encomenda') + sn. tipoProcesso fica oculto. Pedagio
           extraido do PDF pelo cte-parser, editavel pelo usuario. -->
      <div class="po-row" *ngIf="doc.especie === 'CTE'">
        <po-select
          class="po-md-6"
          p-label="TES"
          [ngModel]="doc.tipoOperacao"
          (p-change)="onTipoOperacaoCteChange(doc, $event)"
          [ngModelOptions]="{standalone: true}"
          [p-options]="getTesCteOptions(doc)"
          p-required>
        </po-select>

        <po-decimal
          class="po-md-3"
          p-label="Valor Pedágio"
          [(ngModel)]="doc.valorPedagio"
          [ngModelOptions]="{standalone: true}"
          [p-decimals-length]="2">
        </po-decimal>

        <po-switch
          class="po-md-3"
          p-label="Emitente Simples Nacional"
          p-label-on="Sim"
          p-label-off="Não"
          [(ngModel)]="doc.simplesNacional"
          (p-change)="onSimplesNacionalChange(doc, $event)"
          [ngModelOptions]="{standalone: true}">
        </po-switch>
      </div>

      <!-- Fluxo OCULTO: usuario informa diretamente Conta/BU/CC/Produto.
           A cascata Produto depende da Conta Contabil escolhida. -->
      <div class="po-row" *ngIf="grupo.fornecedorOculto">
        <po-select
          class="po-md-6"
          p-label="Conta Contábil"
          [ngModel]="doc.contaContabil"
          (p-change)="onDocContaContabilChange(doc, $event)"
          [ngModelOptions]="{standalone: true}"
          [p-options]="ocultoContaOptions"
          p-required>
        </po-select>

        <po-select
          class="po-md-6"
          p-label="Produto"
          [ngModel]="doc.produto"
          (ngModelChange)="doc.produto = $event"
          [ngModelOptions]="{standalone: true}"
          [p-options]="doc.produtoOptionsOculto"
          [p-disabled]="!doc.contaContabil ? 'true' : 'false'"
          p-required>
        </po-select>
      </div>

      <div class="po-row" *ngIf="grupo.fornecedorOculto">
        <po-select
          class="po-md-6"
          p-label="BU"
          [ngModel]="doc.bu"
          (ngModelChange)="doc.bu = $event"
          [ngModelOptions]="{standalone: true}"
          [p-options]="ocultoBuOptions"
          p-required>
        </po-select>

        <po-select
          class="po-md-6"
          p-label="Centro de Custo"
          [ngModel]="doc.centroCusto"
          (ngModelChange)="doc.centroCusto = $event"
          [ngModelOptions]="{standalone: true}"
          [p-options]="ocultoCcOptions"
          p-required>
        </po-select>
      </div>

      <!-- ANEXOS -->
      <div class="anexos">
        <div class="anexo-slot"
             [class.anexo-slot--drag]="doc.danfeDragOver"
             (dragover)="onSlotDragOver($event, doc, 'danfe')"
             (dragleave)="onSlotDragLeave($event, doc, 'danfe')"
             (drop)="onSlotDrop($event, doc, 'danfe')">
          <span class="anexo-slot__label">DANFE (PDF)</span>
          <label class="anexo-slot__btn">
            <span class="po-icon an an-paperclip"></span>
            <span class="anexo-slot__btn-text">
              {{ doc.danfeFile ? doc.danfeFile.name : 'Selecionar ou arraste aqui' }}
            </span>
            <input
              type="file"
              accept=".pdf,application/pdf"
              (change)="onFileSelected($event, doc, 'danfe')"
              hidden>
          </label>
          <a *ngIf="doc.danfeFile" class="anexo-slot__clear" (click)="clearFile(doc, 'danfe')">Remover</a>
        </div>

        <div class="anexo-slot"
             [class.anexo-slot--drag]="doc.boletoDragOver"
             [class.anexo-slot--disabled]="!doc.fin"
             (dragover)="doc.fin && onSlotDragOver($event, doc, 'boleto')"
             (dragleave)="onSlotDragLeave($event, doc, 'boleto')"
             (drop)="doc.fin && onSlotDrop($event, doc, 'boleto')">
          <span class="anexo-slot__label">Boleto (PDF)</span>
          <label class="anexo-slot__btn">
            <span class="po-icon an an-paperclip"></span>
            <span class="anexo-slot__btn-text">
              {{ !doc.fin
                   ? 'Disponivel apenas com Gera Financeiro = Sim'
                   : (doc.boletoFile ? doc.boletoFile.name : 'Selecionar ou arraste aqui') }}
            </span>
            <input
              type="file"
              accept=".pdf,application/pdf"
              (change)="onFileSelected($event, doc, 'boleto')"
              [disabled]="!doc.fin"
              hidden>
          </label>
          <a *ngIf="doc.boletoFile && doc.fin" class="anexo-slot__clear" (click)="clearFile(doc, 'boleto')">Remover</a>
        </div>

        <div class="anexo-slot"
             [class.anexo-slot--drag]="doc.romaneioDragOver"
             (dragover)="onSlotDragOver($event, doc, 'romaneio')"
             (dragleave)="onSlotDragLeave($event, doc, 'romaneio')"
             (drop)="onSlotDrop($event, doc, 'romaneio')">
          <span class="anexo-slot__label">Romaneio (PDF)</span>
          <label class="anexo-slot__btn">
            <span class="po-icon an an-paperclip"></span>
            <span class="anexo-slot__btn-text">
              {{ doc.romaneioFile ? doc.romaneioFile.name : 'Selecionar ou arraste aqui' }}
            </span>
            <input
              type="file"
              accept=".pdf,application/pdf"
              (change)="onFileSelected($event, doc, 'romaneio')"
              hidden>
          </label>
          <a *ngIf="doc.romaneioFile" class="anexo-slot__clear" (click)="clearFile(doc, 'romaneio')">Remover</a>
        </div>
      </div>

    </div>

    <po-divider></po-divider>

    <div class="po-row po-mt-1">
      <po-button
        class="po-mr-1"
        p-kind="secondary"
        p-label="Adicionar Documento"
        p-icon="an an-plus"
        p-small
        (p-click)="adicionarDocumento(grupo)">
      </po-button>

      <po-button
        p-label="Excluir Grupo"
        p-icon="an an-x-circle"
        p-small
        p-danger
        (p-click)="excluirGrupo(i)">
      </po-button>
    </div>

  </po-widget>

</po-page-default>
